/**
 * Redux internal
 */
import { reducers } from './_internal';

export default { reducers };
